import useSWR from 'swr';

import { SWR_GLOBAL_CONFIG } from '~/api/_constant';
import { request } from '~/api/_utils/request';

import { ApiOrganization } from '../get';

const getPath = (uid?: string) => `/v1/organizations/${uid}`;

export async function apiGetV1OrganizationById(uid?: string) {
  if (!uid) return;
  const { organization } = await request.GET<{ organization: ApiOrganizationShow }>(getPath(uid));
  return organization;
}

type SWROption = {
  defaultValue?: ApiOrganizationShow;
};

export function useSWRV1OrganizationById(uid?: string, option: SWROption = {}) {
  const swr = useSWR(getPath(uid), () => apiGetV1OrganizationById(uid), {
    ...SWR_GLOBAL_CONFIG,
    fallbackData: option.defaultValue,
  });
  return { ...swr, org: swr.data };
}

/** railsの`app/serializers/v1/organization_serializers/show.rb`に該当 */
export interface ApiOrganizationShow extends ApiOrganization {
  replies?: Reply[];
  social_issues: SocialIssue[];
}

type Reply = {
  id: number;
  text: string;
  created_at: string;
  deletable: boolean;
  images: string[];
  organization: ApiOrganization;
  postable_user?: PostableUser;
  postable_organization?: ApiOrganization;
};

type PostableUser = {
  id: number;
  name: string;
  birth: string;
  gender: string;
  area: string;
  avatar?: string;
  title: string;
  profile?: string;
};

type SocialIssue = {
  id: number;
  name: string;
  color?: string;
  image?: string;
  sdgs?: number[];
  description?: string;
  type: string;
  font_color?: string;
  title: string;
  display_name?: string;
  created_at: string;
  sdgs_score?: number[];
  social_issue_category?: SocialIssueCategory;
};

type SocialIssueCategory = {
  id: number;
  name: string;
  color: string;
};
